import React from 'react'
import classNames from 'classnames'

import './DrawerImage.less'

const DrawerImage = ({
  className,
  imageUrl,
  large,
  children
}: {
  className?: string
  imageUrl?: string | null
  large?: boolean
  children?: React.ReactNode
}) => {
  if (!imageUrl) {
    return null
  }

  return (
    <div
      className={classNames('DrawerImage', className, {
        large: !!large
      })}
      style={{
        backgroundImage: `url(${imageUrl})`
      }}
    >
      <div className="DrawerImage__controls">{children}</div>
    </div>
  )
}

export default DrawerImage
